import React, { CSSProperties, ReactNode, useContext, useState } from 'react';
import DataTableNew from '../../../components/main/DataTableNew/DataTableNew';
import DeleteWorksetsDialog from '../../../components/dialogs/DeleteWorksetsDialog/DeleteWorksetsDialog';
import NewWorksetDialog from '../../../components/dialogs/NewWorksetDialog/NewWorksetDialog';
import { ClientContext } from '../Clients.Provider';
import { UserRoleEnum, Workset } from '../../../generated/graphql';
import ShowOnRole from '../../../components/main/ShowOnRole/ShowOnRole';
import { Plus, Trash2 } from 'lucide-react';
import RefreshButton from '../../../components/main/RefreshButton/RefreshButton';

type WorksetsProps = {
    refresh: () => void;
    worksets: (Workset | null | undefined)[],
    isLoading: boolean,
    clientId: string,
    style?: CSSProperties | undefined,
    children?: ReactNode | undefined,
};

const Worksets = (props: WorksetsProps) => {
    const { worksets, isLoading, clientId, refresh } = props;
    const [newWorksetVisible, setNewWorksetVisible] = useState(false);
    const [selectedIds, setSelectedIds] = useState<string[]>([]);
    const [deleteWorksetsDialogVisible, setDeleteWorksetsDialogVisible] = useState(false);

    const client = useContext(ClientContext);

    const handleDeleteWorksetOnClose = () => {
        setDeleteWorksetsDialogVisible(false);
        refresh();
    };
    const handleNewWorksetDialogOnClose = () => {
        setNewWorksetVisible(false);
        refresh();
    };

    return (
        <div className="flex flex-col h-full">
            <div className="flex-shrink-0 flex items-center gap-2 px-4 py-2.5 border-b" style={{ borderColor: 'var(--border-default)' }}>
                <RefreshButton onRefresh={() => refresh()} />
                <ShowOnRole roles={[UserRoleEnum.Admin]} isAdmin={(client && client.data?.Client?.isAdmin) || false}>
                    <button className="btn btn-ghost text-sm" onClick={() => setNewWorksetVisible(true)}>
                        <Plus size={15} /> New Workset
                    </button>
                    {selectedIds.length > 0 && (
                        <>
                            <div className="w-px h-5 mx-1" style={{ backgroundColor: 'var(--border-default)' }} />
                            <button className="btn btn-ghost text-sm" style={{ color: 'var(--danger)' }} onClick={() => setDeleteWorksetsDialogVisible(true)}>
                                <Trash2 size={15} /> Delete
                            </button>
                        </>
                    )}
                </ShowOnRole>
            </div>

            <div className="flex-1 min-h-0 relative">
                <div className="absolute inset-0">
                <DataTableNew
                    sortingMode="client"
                    isLoading={isLoading}
                    data={worksets as any[]}
                    columns={[{ id: 'group', name: 'Group', sortable: true }]}
                    onSelected={(ids) => setSelectedIds(ids)}
                />
                </div>
            </div>

            <NewWorksetDialog clientId={clientId} visible={newWorksetVisible} onClose={handleNewWorksetDialogOnClose} />
            <DeleteWorksetsDialog clientId={clientId} ids={selectedIds} visible={deleteWorksetsDialogVisible} onClose={handleDeleteWorksetOnClose} />
        </div>
    );
};

export default Worksets;
